import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"white-space":"pre-line"} }

import SogPage from "@/shared/ui/SogPage.vue";
import {onMounted, ref} from "vue";
import {onBeforeRouteUpdate, useRouter,} from "vue-router";
import {useSpinner} from "@/shared/composables/SogSpinner";
import SogUploader from "@/shared/ui/SogUploader.vue";
import {TempFileInfo} from "@/shared/model/TempFileInfo";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {useAccountStore} from "@/stores/accountStore";
import notificationService from "@/shared/services/NotificationService";
import SogDatePicker from "@/shared/ui/SogDatePicker.vue";
import SogFlexColumn from "@/shared/ui/SogFlexColumn.vue";
import apiLossAdjuster from "@/modules/LossAdjuster/api";
import SogGrid from "@/shared/ui/SogGrid.vue";
import {Api} from "@/shared/services/api";
import {ColumnModel} from "@syncfusion/ej2-grids/src/grid/models/column";
import {DateColumn, DateTimeColumn, DefaultColumn,} from "@/shared/ui/types/SogGridColumnDefinitions";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import {IdType} from "@/shared/model/idType";
import apiFileUtils from "@/modules/FileUtils/api";
import apiFile from "@/shared/services/apiFile";



export default /*@__PURE__*/_defineComponent({
  __name: 'BordereauPage',
  setup(__props) {

const _uploader = ref<InstanceType<typeof SogUploader> | null>(null)

const _title = ref("Bordereau hochladen")
const _spinner = useSpinner()
const _api = apiLossAdjuster
const _array = ref<TempFileInfo[]>([])
const _accountStore = useAccountStore()
const _router = useRouter()
const _cutOfDay = ref(new Date())
const _grid = ref<InstanceType<typeof SogGrid> | null>(null)
const _url = Api.baseUrl + '/LossAdjusterUploadList';
const _columns: ColumnModel[] = [
  /*
  { type: 'checkbox' },
*/
  {
    ...DefaultColumn,
    headerText: "",
    visible: true,
    commands: [
      {
        buttonOption: {
          cssClass: "e-flat",
          iconCss: "e-download e-icons",
          click: onClickDetails,
        },
      },
    ],
    textAlign: "Left",
    uid: "details",
    autoFit: true,
    width: "60px",

  },
  {...DefaultColumn, field: 'id', headerText: 'id', isPrimaryKey: true, visible: false},
  {...DefaultColumn, field: 'fileName', headerText: 'Datei'},
  {...DateColumn, field: 'cutOfDate', headerText: 'Datum'},
  {...DateTimeColumn, field: 'uploadDate', headerText: 'hochgeladen'},
  {...DefaultColumn, field: 'statusText', headerText: 'Status'},
  {...DefaultColumn, field: 'personName', headerText: ''},

]

const _errors = ref<string | undefined>();
const _buttonId = ref("");


async function p_init() {
  _spinner.show()
  try {
    if (_accountStore.person && !_accountStore.person.isLossAdjuster() && !_accountStore.isRoot) {
      _router.back()
    }
  } finally {
    _spinner.hide()
  }
}

onMounted(async () => {
  await p_init()
})

onBeforeRouteUpdate(async () => {
  await p_init()
});


async function onImport() {
  if (_array.value.length !== 1)
    return;
  _spinner.show()
  const res = await _api.upload(_array.value[0].id, _array.value[0].fileName, _cutOfDay.value);
  if (res) {
    notificationService.success("Datei " + _array.value[0].fileName + " wurde hochgeladen")
    _uploader.value?.clear()
    _grid.value?.refresh()
    _spinner.hide()
  }
}


function onSelected(data: any) {
  _errors.value = data?.errors
}

function onRefresh() {
  _grid.value?.refresh()
}

async function onClickDetails() {
  _buttonId.value = "download";
}

async function onClick(args: any) {
  //console.log(args.rowData)
  if (_buttonId.value === "download") {
    _spinner.show()
    const fileId = await apiLossAdjuster.initDownloadFile(args.rowData.id ?? "");
    if (fileId) await apiFile.downloadTempFile(fileId, args.rowData.fileName);
    _spinner.hide()

  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, {
    id: "page",
    title: _title.value
  }, {
    default: _withCtx(() => [
      _createVNode(SogCard, { class: "sog-card-without-title" }, {
        default: _withCtx(() => [
          _createVNode(SogCardActions, { "is-toolbar": true }, {
            default: _withCtx(() => [
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Refresh,
                onClick: onRefresh
              }, null, 8, ["kind"]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Back
              }, null, 8, ["kind"])
            ]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(SogFlexColumn, null, {
                default: _withCtx(() => [
                  _createVNode(SogDatePicker, {
                    modelValue: _cutOfDay.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_cutOfDay).value = $event)),
                    placeholder: "Berichtsdatum"
                  }, null, 8, ["modelValue"]),
                  _cache[2] || (_cache[2] = _createTextVNode(" Wählen Sie ein Datei aus ", -1)),
                  _createVNode(SogUploader, {
                    ref_key: "_uploader",
                    ref: _uploader,
                    modelValue: _array.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_array).value = $event)),
                    multiple: false,
                    "allowed-extensions": ".xls,.xlsx"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(SogCardActions, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-upload",
                onClick: onImport
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode(" importieren ", -1)
                ]))]),
                _: 1
              }, 512), [
                [_vShow, _array.value.length>0]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogGrid, {
            ref_key: "_grid",
            ref: _grid,
            url: _url,
            columns: _columns,
            width: "auto",
            "on-command-click": onClick,
            onSelected: onSelected
          }, null, 512)
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Importresultat", -1)
            ]))]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, _toDisplayString(_errors.value), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512), [
        [_vShow, _errors.value]
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})